import { useState } from "react";
import { useInView } from "react-intersection-observer";
import styled from "styled-components";
import H1 from "../../../components/typography/H1";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";
import JournalCard from "./JournalCard";
import journals from "../../../assets/store/journals";

const Wrapper = styled.div``;

const Container = styled.div`
  display: flex;
  padding: 20px 40px;
  gap: 24px;
  flex-direction: column;
  align-items: center;

  @media (max-width: 950px) {
    padding: 20px;
  }
`;

const TabsWrapper = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  cursor: pointer;
  text-align: center;
  align-items: center;
  justify-content: center;
`;

const Tab = styled.span`
  position: relative;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  letter-spacing: 0.1rem;
  text-transform: capitalize;
  color: ${colors.black};
  font-size: ${fontSize.xxs};

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -4px;
    width: 100%;
    height: 1px;
    background-color: ${colors.black};
    transform: translateX(-50%) scaleX(${(props) => (props.active ? 1 : 0)});
    transform-origin: center;
    transition: transform 0.3s ease;
  }

  &:hover::after {
    transform: translateX(-50%) scaleX(1);
  }
`;

const JournalsWrapper = styled.div`
  display: grid;
  row-gap: 64px;
  column-gap: 24px;
  margin-top: 24px;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  @media (max-width: 950px) {
    row-gap: 0px;
    column-gap: 0px;
    gap: 64px !important;
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

const TABS = [
  "ALL",
  "ANIMALS AND SURROUNDINGS",
  "CLOTHING",
  "COLORS",
  "CRAFT",
  "HOME",
  "PEOPLE",
  "PROCESS",
  "LIFESTYLE",
  "RELIGION AND CULTURE",
];

function JournalsGrid() {
  const { ref, inView } = useInView({ triggerOnce: true });
  const [activeTab, setActiveTab] = useState(TABS[0]);

  return (
    <Wrapper ref={ref} inView={inView}>
      <Container>
        <H1>OUR JOURNAL</H1>
        <TabsWrapper>
          {TABS.map((tab) => (
            <Tab active={activeTab === tab} onClick={() => setActiveTab(tab)}>
              {tab}
            </Tab>
          ))}
        </TabsWrapper>

        <JournalsWrapper>
          {journals.map((journal) => (
            <JournalCard key={journal} journal={journal} />
          ))}
        </JournalsWrapper>
      </Container>
    </Wrapper>
  );
}

export default JournalsGrid;
